import api from ".";
import { formSchemaEndpoints } from "./endpoints/formSchema.endpoints";

export const formSchemaApis = {
  getAllSchemas: async (params = {}) => {
    try {
      const { sector, q, limit, page } = params;
      const queryParams = new URLSearchParams();
      if (sector) queryParams.append("sector", sector);
      if (q) queryParams.append("q", q);
      if (limit) queryParams.append("limit", limit);
      if (page) queryParams.append("page", page);

      const queryString = queryParams.toString();
      const url = queryString
        ? `${formSchemaEndpoints.getAll}?${queryString}`
        : formSchemaEndpoints.getAll;

      const res = await api.get(url);
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching form schemas");
    }
  },

  getSchemaById: async (id) => {
    try {
      const res = await api.get(formSchemaEndpoints.getById(id));
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching form schema");
    }
  },

  getSchemasBySector: async (sector) => {
    try {
      // Encode sector name to handle spaces and special characters
      const encodedSector = encodeURIComponent(sector);
      const res = await api.get(formSchemaEndpoints.getBySector(encodedSector));
      // The backend returns an array directly, not wrapped in data property
      return Array.isArray(res.data) ? res.data : (res.data?.data || res.data || []);
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching form schemas by sector");
    }
  },

  createSchema: async (data) => {
    try {
      const res = await api.post(formSchemaEndpoints.create, data);
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error creating form schema");
    }
  },

  updateSchema: async (id, data) => {
    try {
      const res = await api.put(formSchemaEndpoints.update(id), data);
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error updating form schema");
    }
  },

  deleteSchema: async (id) => {
    try {
      const res = await api.delete(formSchemaEndpoints.delete(id));
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error deleting form schema");
    }
  },
};

